import { useEffect } from "react";

/**
 * Lightweight per-route SEO helper.
 *
 * Updates <title>, <meta name="description">, <link rel="canonical"> and the
 * Open Graph / Twitter tags without pulling in react-helmet. Called from each
 * page component with the copy tuned for that route.
 */
const SITE = "https://samur-ai.in";

const setMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const SEO = ({ title, description, path = "/", image, type = "website" }) => {
  useEffect(() => {
    if (title) document.title = title;
    setMeta("name", "description", description);
    const canonical = `${SITE}${path.startsWith("/") ? path : `/${path}`}`;
    setLink("canonical", canonical);
    // Open Graph
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", canonical);
    setMeta("property", "og:type", type);
    setMeta("property", "og:site_name", "SAMURAI");
    if (image) setMeta("property", "og:image", image);
    // Twitter
    setMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    if (image) setMeta("name", "twitter:image", image);
  }, [title, description, path, image, type]);

  return null;
};

export default SEO;
